module.exports = __webpack_public_path__ + "img/sanae kochiya lunar war oracle_lw.36042160.png";